import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import "../styles/Footer.css";
import Facebook from "../assets/facebook.png";
import Youtube from "../assets/youtube.png";
import Linkedin from "../assets/linkedin.png";
import Logo from "../assets/fav.svg";

const FooterContainer = styled.div`
  width: 100%;
  height: 300px;
  background: #f5f5f5;
  @media (max-width: 768px) {
    height: auto;
  }
`;

const LogoImgBig = styled.img`
  width: 60px;
  height: 60px;
`;

const FooterBody = styled.div`
  width: 80%;
  height: 60%;
  margin-left: 10%;
  padding: 3% 0;
  display: flex;
  flex-flow: row;
  @media (max-width: 768px) {
    width: 90%;
    margin-left: 5%;
    height: auto;
    display: block;
  }
`;

const Part1 = styled.div`
  width: 28%;
  height: 100%;
  padding-right: 2%;
  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    margin-bottom: 30px;
  }
`;

const Part2 = styled.div`
  width: 18%;
  height: 100%;
  @media (max-width: 768px) {
    width: 100%;
    height: auto;
    margin-bottom: 30px;
  }
`;
const SocialLink = styled.button`
  background: none;
  border: none;
  cursor: pointer;
`;
const SocialImg = styled.img`
  width: 28px;
  height: 28px;
`;
const footer = () => {
  return (
    <FooterContainer>
      <FooterBody className="Footer">
        <Part1>
          <Link to="/">
            <LogoImgBig src={Logo} alt="Mamatovai" />
          </Link>
          <p style={{ fontSize: "14px", color: "gray" }}>
            PhysiTaL Market (Physical + Digital + Local).
            <br />4 T Model: Trust in Trade, Transaction & Technology.
            <br /> Online Shopping From Nearby Shops.
            <br />
            Shops Near Me.
          </p>
        </Part1>
        <Part2>
          <h2>Company</h2>
          <ul>
            <li>
              <Link to="/about">About</Link>
            </li>
            <li>
              <Link>Blog</Link>
            </li>
            <li>
              <Link>Career</Link>
            </li>
            <li>
              <Link>Contacts</Link>
            </li>
          </ul>
        </Part2>
        <Part2>
          <h2>For Shop</h2>
          <ul>
            <li>
              <Link to="/shop-request">Open shop</Link>
            </li>
            <li>
              <Link to="/merchant/login">Login to merchant panel</Link>
            </li>
            <li>
              <Link to="/shop-terms">Terms And Conditons</Link>
            </li>
            {/* <li>
              <Link>Contacts</Link>
            </li> */}
          </ul>
        </Part2>
        <Part2>
          <h2>For you</h2>
          <ul>
            <li>
              <Link to="/customer-terms">Terms And Conditons</Link>
            </li>
            <li>
              <Link to="/privacy">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/privacy">Data Secuirity</Link>
            </li>
            {/* 
            <li>
              <Link>Contacts</Link>
            </li> */}
          </ul>
        </Part2>
        <Part2>
          <h2>Scoial Links</h2>
          <SocialLink>
            <a href="https://www.facebook.com/" target="blank">
              <SocialImg src={Facebook} />
            </a>
          </SocialLink>
          <SocialLink>
            <a href="https://www.youtube.com/" target="blank">
              <SocialImg src={Youtube} />
            </a>
          </SocialLink>
          <SocialLink>
            <a href="https://www.linkedin.com/" target="blank">
              <SocialImg src={Linkedin} />
            </a>
          </SocialLink>
          <h2 style={{ padding: "20px 0 5px 0", margin: "0" }}>Contact </h2>
          <p style={{ padding: "0", margin: "0" }}>
            House - 06, Road - 17, Uttara, Dhata.
          </p>
          {/* <ul>
            <li>
              <Link>About</Link>
            </li>
            <li>
              <Link>Blog</Link>
            </li>
            <li>
              <Link>Career</Link>
            </li>
            <li>
              <Link>Contacts</Link>
            </li>
          </ul> */}
        </Part2>
      </FooterBody>
    </FooterContainer>
  );
};

export default footer;
